<template minapp="mpx" xlang="wxml">
  <view style="width: 100%">
    <view
      wx:class="{{isScramble ? 'train-list-condition-container-scramble' : 'train-list-condition-container'}}"
    >
      <view
        wx:class="{{isScramble ? 'train-list-condition-bar-scramble' : 'train-list-condition-bar'}}"
        wx:style="{{safePadding}}"
      >
        <view
          class="bar-item"
          wx:class="{{{select: startTimeSelected}}}"
          bindtap="showSortCriteriaDrawer('start')"
        >
          {{ startTimeBar }}
        </view>
        <view
          class="bar-item"
          wx:class="{{{select: travelTimeSelected}}}"
          bindtap="showSortCriteriaDrawer('time')"
        >
          {{ travelTimeBar }}
        </view>
        <view
          class="bar-item"
          wx:class="{{{select: priceSelected}}}"
          bindtap="showSortCriteriaDrawer('price')"
        >
          {{ priceBar }}
        </view>
        <view class="bar-item" bindtap="showFilterConditionDrawer">
          <view class="icon"></view>
          筛选
          <view class="number" wx:if="{{conditionNumber}}">{{ conditionNumber }}</view>
        </view>
      </view>
    </view>
    <train-list-filter-condition-drawer
      show="{{filterConditionDrawerVisible}}"
      trainListSearchQuery="{{trainListSearchQuery}}"
      selectCityList="{{selectCityList}}"
      condition="{{condition}}"
      isScramble="{{isScramble}}"
      unionType="{{unionType}}"
      bind:parentDataChange="parentDataChange"
      bind:conditionChange="conditionChange"
      bind:close="hiddenFilterConditionDrawer"
      bind:getTrainListFunc="getTrainListFunc"
    />
  </view>
</template>

<script>
  import { mpx, createComponent } from '@didi/es-mpx-creator'
  import store from '@/store'
  import { setStorage } from '@/utils/storage'
  import {
    STORAGE_LIST_SEARCH_QUERY,
    STORATE_CONDITION_SEARCH_QUERY,
    STORATE_SCRAMBLE_CONDITION_SEARCH_QUERY
  } from '@/utils/train-storage'
  import { getStorage } from '../../../../utils/storage'

  createComponent({
    props: {
      trainListSearchQuery: {
        type: Object,
        value: {}
      },
      selectCityList: {
        type: Array,
        value: []
      },
      isScramble: {
        type: Boolean,
        value: false
      },
      unionType: {
        type: Number,
        value: 0
      }
    },
    data: {
      startTimeSelected: false,
      travelTimeSelected: false,
      priceSelected: false,
      // ticketSelected: false,
      filterConditionDrawerVisible: false,
      condition: {
        train_type_code: [],
        start_time_list: [],
        end_time_list: [],
        from_city_match: [],
        to_city_match: [],
        passenger_type: '',
        preferred_tickets: '',
        is_fxh: '',
        is_zndc: '',
        is_quiet: '0',
        transfer_city_match: [],
        transfer_station_type: 0
      }
    },
    mounted() {
      const _condition = this.isScramble
        ? getStorage(STORATE_SCRAMBLE_CONDITION_SEARCH_QUERY)
        : getStorage(STORATE_CONDITION_SEARCH_QUERY)
      _condition && Object.keys(_condition).length && (this.condition = { ..._condition })
    },
    computed: {
      ...store.mapState({
        DEFAULT_FROM_CITY: 'travel.DEFAULT_FROM_CITY',
        DEFAULT_TO_CITY: 'travel.DEFAULT_TO_CITY'
      }),
      startTimeBar() {
        const { trainListSearchQuery } = this
        let content = ''
        if (trainListSearchQuery?.order_by === 'start') {
          if (trainListSearchQuery?.order_rules === 'asc') {
            content = '最早'
            this.startTimeSelected = true
          } else if (trainListSearchQuery?.order_rules === 'desc') {
            content = '最晚'
            this.startTimeSelected = true
          } else {
            this.startTimeSelected = false
          }
        }
        return '出发' + content
      },
      // ticketBar() {
      //   const { trainListSearchQuery } = this
      //   if (trainListSearchQuery?.preferred_tickets === '1') {
      //     this.ticketSelected = true
      //   } else {
      //     this.ticketSelected = false
      //   }
      //   return '有票优先'
      // },
      travelTimeBar() {
        const { trainListSearchQuery } = this
        let content = '耗时'
        if (trainListSearchQuery?.order_by === 'time') {
          if (trainListSearchQuery?.order_rules === 'asc') {
            content = '耗时最短'
            this.travelTimeSelected = true
          } else if (trainListSearchQuery?.order_rules === 'desc') {
            content = '耗时最长'
            this.travelTimeSelected = true
          } else {
            this.travelTimeSelected = false
          }
        }
        return content
      },
      priceBar() {
        const { trainListSearchQuery } = this
        let content = '价格'
        if (trainListSearchQuery?.order_by === 'price') {
          if (trainListSearchQuery?.order_rules === 'asc') {
            content = '价格最低'
            this.priceSelected = true
          } else if (trainListSearchQuery?.order_rules === 'desc') {
            content = '价格最高'
            this.priceSelected = true
          } else {
            this.priceSelected = false
          }
        }
        return content
      },
      conditionNumber() {
        let number = 0
        Number(this.condition.is_fxh) && number++
        Number(this.condition.is_quiet) && number++
        Number(this.condition.is_zndc) && number++
        Number(this.condition.preferred_tickets) && number++
        this.condition.passenger_type === '13' && number++
        this.condition.start_time_list?.length &&
          (number = number + this.condition.start_time_list?.length / 2)
        this.condition.end_time_list?.length &&
          (number = number + this.condition.end_time_list?.length / 2)
        this.condition.from_city_match?.length &&
          (number = number + this.condition.from_city_match?.length)
        this.condition.to_city_match?.length &&
          (number = number + this.condition.to_city_match?.length)
        this.condition.transfer_city_match?.length &&
          (number = number + this.condition.transfer_city_match?.length)
        this.condition.transfer_station_type && number++
        this.condition.train_type_code?.length &&
          (number = number + this.condition.train_type_code?.length)
        return number
      },
      safePadding() {
        const system = mpx.getSystemInfoSync()
        return system?.platform === 'iPhone' ? { paddingBottom: '38px' } : { paddingBottom: '10px' }
      }
    },
    methods: {
      showSortCriteriaDrawer(type) {
        this.$trigger('reportClick', type)
        // const keysMap = {
        //   start: 'order_by_start_time',
        //   time: 'order_by_travel_time',
        //   '0': '1',
        //   '1': '0',
        //   price: 'order_by_show_price'
        // }
        const trainListSearchQuery = { ...this.trainListSearchQuery }
        // const selectKey = keysMap[type]
        const orderRules =
          trainListSearchQuery?.order_by === type && trainListSearchQuery?.order_rules === 'asc'
            ? 'desc'
            : 'asc'
        // delete trainListSearchQuery.order_by_start_time
        // delete trainListSearchQuery.order_by_travel_time
        // delete trainListSearchQuery.order_by_show_price
        const newTrainListSearchQuery = {
          ...trainListSearchQuery,
          order_by: type,
          order_rules: orderRules
        }
        !this.isScramble &&
          setStorage({ key: STORAGE_LIST_SEARCH_QUERY, data: newTrainListSearchQuery })
        this.parentDataChange({
          detail: {
            key: 'trainListSearchQuery',
            value: newTrainListSearchQuery
          }
        })
        this.getTrainListFunc()
      },
      showFilterConditionDrawer() {
        this.$trigger('reportClick', 'screen')
        this.filterConditionDrawerVisible = true
      },
      hiddenFilterConditionDrawer() {
        this.filterConditionDrawerVisible = false
      },
      parentDataChange({ detail: params }) {
        this.$trigger('parentDataChange', params)
      },
      conditionChange({ detail }) {
        this.condition = detail
        if (!this.isScramble) {
          setStorage({ key: STORATE_CONDITION_SEARCH_QUERY, data: detail })
        } else {
          setStorage({ key: STORATE_SCRAMBLE_CONDITION_SEARCH_QUERY, data: detail })
        }
      },
      getTrainListFunc() {
        this.$trigger('getTrainListFunc')
      },
      // changeTicketSelected() {
      //   this.$trigger('reportClick', 'ticket')
      //   this.ticketSelected = !this.ticketSelected
      //   this.search()
      // },
      search() {
        const trainListSearchQuery = { ...this.trainListSearchQuery }
        this.newTrainListSearchQuery = {
          ...trainListSearchQuery,
          preferred_tickets: this.ticketSelected ? '1' : '0'
        }
        const finalTrainListSearchQuery = this.newTrainListSearchQuery ?? this.trainListSearchQuery
        !this.isScramble &&
          setStorage({ key: STORAGE_LIST_SEARCH_QUERY, data: finalTrainListSearchQuery })
        console.log('finalTrainListSearchQuery', finalTrainListSearchQuery)
        this.$trigger('parentDataChange', {
          key: 'trainListSearchQuery',
          value: finalTrainListSearchQuery
        })
        this.getTrainListFunc()
      }
    }
  })
</script>

<style lang="stylus" scoped>
  @import '~@/mixins/stylus/color.styl'

  .train-list-condition-container
    // margin-left 8px
    // width calc(100% - 16px)
    width 100%
    position relative
    // height 76px
    background #f3f4f5
    border-radius 16px 16px 0 0
  .train-list-condition-container-scramble
    width 100%
    position sticky
    top 0
    left 0
    height 52px
  .train-list-condition-bar
    // width calc(100% - 16px)
    width 100%
    height 52px
    line-height 52px
    background #ffffff
    box-shadow 0 12px 12px 0 RGBA(0, 0, 0, 0.06)
    position relative
    border-radius 12px
    display flex
    justify-content space-between
    align-items center
  .train-list-condition-bar-scramble
    width 100%
    height 52px
    line-height 52px
    background #ffffff
    position fixed
    display flex
    justify-content space-between
    align-items center
  .split-line
    display flex
    align-items center
  .split-line::before
    width 1px
    height 14px
    background #e6e6e6
    content ' '
  .bar-item
    flex 1
    color #222222
    font-size 14px
    font-weight 400
    display flex
    justify-content center
    align-items center
    position relative
    .icon
      margin-left 2px
  .bar-item.select
    color #222222
    font-family PingFangSC-Medium
    position relative
    &::before
      position absolute
      content ''
      height 4px
      width 10px
      background #FF6400
      border-radius 2px
      bottom 11px
      left 42px
  .icon
    width 10.5px
    height 11px
    background url('https://dpubstatic.udache.com/static/dpubimg/ChGvbgZKpfdbTlvpaQRIU.png')
    background-size cover
    margin-right 2px
  .number
    width 12.5px
    height 12.5px
    border-radius 50%
    background #FF4129
    color #FFFFFF
    font-size 9px
    line-height 12.5px
    text-align center
    position absolute
    top 12px
    right 12px
</style>

<script name="json">
  module.exports = {
    component: true,
    usingComponents: {
      'train-list-filter-condition-drawer': './train-list-filter-condition-drawer'
    }
  }
</script>